import Vue from 'vue'
import Router from 'vue-router'
import { Hash } from 'crypto'

Vue.use(Router)


export const router =  new Router({
  routes: [
    {
      path: '/',
      name: '登录',
      component: r => require.ensure([], () => r(require('@/view/login/index')), 'login'),
      meta:{auth:false},
    },
    {
      path: '/home',
      name: '主页',
      component: r => require.ensure([], () => r(require('@/components/index')), 'index'),
      meta:{auth:true},
      redirect:'/index', //路由重定向
      children:[
        {
          path: '/index',
          name: '首页待办',
          showList:true, //左侧菜单是否显示
          component: r => require.ensure([], () => r(require('@/view/index/index')), 'index'),
          meta: { name: "首页待办" ,auth:true ,icon:'el-icon-s-home'}
        },
        {
          path: '/Safe',
          name: '安全中心',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/Safe/index')), 'Safe'),
          meta:{auth:false}
        },
        {
          path: '/complain',
          name: '我的投诉',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/Safe/complain')), 'Safe'),
          meta:{auth:false}
        },
        {
          path: '/retel',
          name: '修改绑定手机',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/Safe/retel')), 'Safe'),
          meta:{auth:false}
        },
        {
          path: '/repwd',
          name: '修改登录密码',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/Safe/repwd')), 'Safe'),
          meta:{auth:false}
        },
        {
          path: '/projectOrder',
          name: '合同订单',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/OrderQuery/projectOrder')), 'projectOrder'),
          meta:{ name: '订单查询', auth:true,icon: 'el-icon-s-order'},
        },
        {
          path: '/projectOrderdetail/:id',
          name: '合同订单详情',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/OrderDetail/projectDetail')), 'projectDetail'),
          meta:{auth:false}
        },
        {
          path: '/everydayOrder',
          name: '每日料单',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/OrderQuery/everydayOrder')), 'everydayOrder'),
          meta:{ name: '订单查询', auth:true,icon: 'el-icon-s-order'}
        },
        {
          path: '/openmap',
          name: '查看地图',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/OrderQuery/openmap')), 'openmap'),
          meta:{auth:false}
        },
        {
          path: '/CarOrderdetail/:id',
          name: '车次详情',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/OrderDetail/carDetail')), 'carDetail'),
          meta:{auth:false}
        },
        {
          path: '/carOrder',
          name: '车次订单',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/OrderQuery/carOrder')), 'carOrder'),
          meta:{ name: '订单查询', auth:true,icon: 'el-icon-s-order'}
        },
        {
          path: '/cashOrderDetail/:id',
          name: '现金详情',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/OrderDetail/cashOrderDetail')), 'cashOrderDetail'),
          meta:{auth:false}
        },
        {
          path: '/cashOrder',
          name: '现金料单',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/OrderQuery/cashOrder')), 'cashOrder'),
          meta:{ name: '订单查询', auth:true,icon: 'el-icon-s-order'}
        },
        {
          path: '/materialOrderdetail/:id',
          name: '料单详情',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/OrderDetail/materialDetail')), 'materialDetail'),
          meta:{auth:false}
        },
        {
          path: '/OrderStatistics',
          name: '订单统计',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/OrderStatistics/index')), 'OrderStatistics'),
          meta: { name: "数据统计" ,auth:true ,icon:'el-icon-s-data'},
        },
        {
          path: '/SignBillStatistics',
          name: '签单统计',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/OrderStatistics/signBillStatistics')), 'signBillStatistics'),
          meta: { name: "数据统计" ,auth:true ,icon:'el-icon-s-data'},
        },
        {
          path: '/StockStatistics',
          name: '备料统计',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/OrderStatistics/stockStatistics')), 'stockStatistics'),
          meta: { name: "数据统计" ,auth:true ,icon:'el-icon-s-data'},
        },
        // {
        //   path: '/MarketStatistics',
        //   name: '市场行情',
        //   showList:true,
        //   component: r => require.ensure([], () => r(require('@/view/OrderStatistics/marketStatistics')), 'stockStatistics'),
        //   meta: { name: "数据统计" ,auth:true ,icon:'el-icon-s-data'},
        // },
        {
          path: '/NewsCentre',
          name: '消息中心',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/NewsCentre/index')), 'NewsCentre'),
          meta: { name: "消息中心" ,auth:true ,icon:'el-icon-s-comment'},
        },
        {
          path: '/CommonCar',
          name: '车辆管理',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/CommonCar/index')), 'CommonCar'),
          meta: { name: "常用车辆" ,auth:true ,icon:'el-icon-truck'},
        },
        {
          path: '/MarketDynamics',
          name: '行情动态',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/MarketDynamics/index')), 'MarketDynamics'),
          meta: { name: "行情动态" ,auth:true ,icon:'el-icon-s-marketing'},
        },
        {
          path: '/PerfectInformation',
          name: '完善资料',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/PerfectInformation/index')), 'PerfectInformation'),
          meta:{auth:false}
        },
        {
          path: '/morePerfect',
          name: '再完善资料',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/PerfectInformation/morePerfect')), 'morePerfect'),
          meta:{auth:false}
        },
        {
          path: '/SiteInformation',
          name: '站点资料',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/SiteInformation/index')), 'SiteInformation'),
          meta:{auth:false}
        },
        {
          path: '/VehicleInfomation',
          name: '车辆管理',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/VehicleInfomation/index')), 'VehicleInfomation'),
          meta:{auth:false}
        },
        {
          path: '/dispatchCar',
          name: '派车',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/dispatchCar/index')), 'dispatchCar'),
          meta:{auth:false}
        },
        {
          path: '/changeMaterial',
          name: '修改订单',
          showList:false,
          component: r => require.ensure([], () => r(require('@/view/OrderDetail/changeMaterial')), 'changeMaterial'),
          meta:{auth:false}
        },
        {
          path: '/fundsmanagement',
          name: '资金管理',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/Myaccount/fundsmanagement')), 'fundsmanagement'),
          meta:{ name: '我的账户', auth:true,icon: 'el-icon-s-order'}
        },
        {
          path: '/invoicemanagement',
          name: '发票管理',
          showList:true,
          component: r => require.ensure([], () => r(require('@/view/Myaccount/invoicemanagement')), 'invoicemanagement'),
          meta:{ name: '我的账户', auth:true,icon: 'el-icon-s-order'}
        },
      ]
    },
    {
      path: '*',
      name: '404',
      component: r => require.ensure([], () => r(require('@/view/notFound/index')), 'notFound'),
      meta:{auth:false},
    },
    
  ],
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js